import { Form, Input, InputNumber, Modal, Radio } from 'antd'
import { useState } from 'react'

import { useUserActions } from '../hooks/useUserActions'

interface Props {
  open: boolean
  userId: string
  userEmail?: string
  onClose: () => void
}

export function ChangeBalanceModal({
  open,
  userId,
  userEmail,
  onClose,
}: Props) {
  const [form] = Form.useForm()
  const [operation, setOperation] = useState<'grant' | 'charge'>('grant')
  const [loading, setLoading] = useState(false)
  const { grantBalance, chargeBalance } = useUserActions()

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields()
      setLoading(true)

      if (operation === 'grant') {
        await grantBalance(userId, String(values.amount), values.description)
      } else {
        await chargeBalance(
          userId,
          String(values.amount),
          values.reason,
          values.description,
        )
      }

      form.resetFields()
      onClose()
    } catch (error) {
      if (error instanceof Error) {
        console.error(error)
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <Modal
      title={`Change Balance · ${userEmail ?? userId}`}
      open={open}
      onOk={handleSubmit}
      okText={operation === 'grant' ? 'Grant' : 'Charge'}
      okButtonProps={{ danger: operation === 'charge' }}
      onCancel={onClose}
      confirmLoading={loading}
      destroyOnHidden
    >
      <Form form={form} layout="vertical" preserve={false}>
        <Form.Item label="Operation">
          <Radio.Group
            value={operation}
            onChange={(e) => setOperation(e.target.value)}
          >
            <Radio.Button value="grant">Grant</Radio.Button>
            <Radio.Button value="charge">Charge</Radio.Button>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          name="amount"
          label="Amount"
          rules={[{ required: true, message: 'Amount is required' }]}
        >
          <InputNumber
            min={0}
            style={{ width: '100%' }}
            placeholder="Enter amount"
          />
        </Form.Item>

        {operation === 'charge' && (
          <Form.Item
            name="reason"
            label="Reason"
            rules={[{ required: true, message: 'Reason is required' }]}
          >
            <Input placeholder="Enter reason" />
          </Form.Item>
        )}

        <Form.Item name="description" label="Description">
          <Input.TextArea placeholder="Optional description" rows={3} />
        </Form.Item>
      </Form>
    </Modal>
  )
}
